import axios from 'axios';
import { MatchingHistoryItem } from '../types';
import { checkForLocalAuthToken } from 'models/AuthModel';

const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;

interface getMatchingHistoryProps {
  org_id: string;
  sort?: {
    field: string;
    order: string;
  };
  nextPage?: string;
  operation_id?: string;
  filters?: any;
  search?: any;
}

interface GetMatchingHistoryReturn {
  data: MatchingHistoryItem[];
  next_page_token?: string;
  hasError: boolean;
}
const token = checkForLocalAuthToken();

export const apiInstance = axios.create({
  baseURL: VITE_APP_API_URL,
  headers: { authorization: `Bearer ${token?.access_token}` },
});

export const getMatchingHistory = async ({
  org_id,
  nextPage,
  sort,
  filters,
  search,
}: getMatchingHistoryProps): Promise<GetMatchingHistoryReturn> => {
  try {
    const response = await apiInstance.post(`/opensearch/v3/product_matching_history/${org_id}`, {
      queries: Object.entries(search || {})
        .filter(([_, value]) => value)
        .map(([key, value]) => ({
          column_name: key,
          search_term: value,
        })),
      sort: sort
        ? {
            order: sort.order === 'descend' ? 'desc' : 'asc',
            column_name: sort.field.toUpperCase(),
          }
        : null,
      filters: Object.entries(filters || {})
        .filter(([_, value]) => value)
        .map(([key, value]) => ({
          column_name: key,
          applied_filters: value,
        })),
      current_page_token: nextPage,
    });

    return {
      data: [] as MatchingHistoryItem[],
      next_page_token: undefined,
      ...response.data,
      hasError: false,
    };
  } catch (err: any) {
    return { data: [] as MatchingHistoryItem[], next_page_token: undefined, hasError: true };
  }
};
